import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import QuestionnairePage from "./QuestionnairePage";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { isPristine } from "redux-form";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import QuestionnairePageLoader from "./QuestionnairePageLoader";

class Questionnaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      showTabChangeDialog: false,
      nextTab: 0
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleOpenDialog = this.handleOpenDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
  }

  handleTabChange = (event, value) => {
    let { isPristineForm } = this.props;
    isPristineForm ? this.setState({ tab: value }) : this.handleOpenDialog();
    this.setState({ nextTab: value });
  };

  handleOpenDialog = () => {
    this.setState({ showTabChangeDialog: true });
  };

  handleCloseDialog = value => {
    this.setState({ showTabChangeDialog: false });
    if (value) this.forceTabChange(this.state.nextTab);
  };

  forceTabChange = value => {
    this.setState({ tab: value });
  };

  render() {
    let { questionnaire, isPristineForm } = this.props;
    let { tab } = this.state;
    let page = questionnaire.pages[tab];
    return (
      <div>
        <div>
          <Dialog
            open={this.state.showTabChangeDialog}
            onClose={this.handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Leave without saving changes?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure to leave the page without saving changes?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.handleCloseDialog(false)}
                color="primary"
              >
                Disagree
              </Button>
              <Button
                onClick={() => this.handleCloseDialog(true)}
                color="primary"
                autoFocus
              >
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <Paper square>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleTabChange}
          >
            {questionnaire.pages.map((page, index) => (
              <Tab label={page.name} />
            ))}
          </Tabs>
        </Paper>
        <QuestionnairePageLoader page={page} />
      </div>
    );
  }
}

Questionnaire.propTypes = {
  questionnaire: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  isPristineForm: isPristine("QuestionnairePage")(state)
});

export default connect(mapStateToProps)(Questionnaire);



// WEBPACK FOOTER //
// ./src/modules/test/components/Questionnaire.js